import {modalTriggerLiveSiteSrc68Evid1232 as modalOpened} from '@wix/bi-logger-events-data/v2'
import {UrlQueryParams, encodeQueryParams} from '@wix/panda-js-utils'
import {ModalActions, ModalResponse, SERVER_BASE_URL} from '@wix/wix-events-commons-statics'
import {FlowAPI} from '@wix/yoshi-flow-editor'
import {setActiveElement} from '../actions/focus-handler'
import {CommonStoreExtraArgs, GetCommonState} from '../types/state'
import {createAsyncAction} from './redux-toolkit'

export const MODAL_OPENED_OLD = 'MODAL_OPENED_OLD'

interface OpenModalProps {
  type: string
  params?: UrlQueryParams
}

export const openModalOld =
  ({type, params}: OpenModalProps) =>
  (
    dispatch: Function,
    _getState: GetCommonState,
    {wixCodeApi, compId, flowAPI}: CommonStoreExtraArgs & {flowAPI: FlowAPI},
  ): Promise<{message: {reason: string}}> => {
    const {t} = flowAPI.translations
    flowAPI?.bi?.report?.(modalOpened({modal_name: type}))
    const queryParams = params ? encodeQueryParams(params) : ''

    dispatch({type: MODAL_OPENED_OLD, modalType: type, params})
    return wixCodeApi.window.openPopup(
      `${SERVER_BASE_URL}/html/modal/${type}${queryParams}`,
      {
        title: t('a11y.modal'),
        theme: 'BARE',
        width: '100%' as any,
        height: '100%' as any,
        position: {
          origin: 'FIXED',
          placement: 'CENTER',
          x: 0,
          y: 0,
        },
      },
      compId,
    )
  }

export const openModal = createAsyncAction<ModalResponse, OpenModalProps>(
  'OPEN_MODAL',
  async ({type, params}, {extra: {wixCodeApi, compId, flowAPI}}) => {
    const {t} = flowAPI.translations
    flowAPI?.bi?.report?.(modalOpened({modal_name: type}))
    const queryParams = params ? encodeQueryParams(params) : ''

    return wixCodeApi.window.openPopup(
      `${SERVER_BASE_URL}/html/modal/${type}${queryParams}`,
      {
        title: t('a11y.modal'),
        theme: 'BARE',
        width: '100%' as any,
        height: '100%' as any,
        position: {
          origin: 'FIXED',
          placement: 'CENTER',
          x: 0,
          y: 0,
        },
      },
      compId,
    )
  },
)
interface OpenGeneralModalProps extends OpenModalProps {
  onConfirm?: (response?: any) => void
  onClose?: (response?: any) => void
  returnFocusElement?: string
}

export const openDialogModalOld =
  ({onConfirm, onClose, returnFocusElement, ...rest}: OpenGeneralModalProps) =>
  async (dispatch: Function) => {
    const response: ModalResponse = await dispatch(openModalOld(rest))
    if (response.message.reason === ModalActions.OK && onConfirm) {
      onConfirm(response)
    } else if (onClose) {
      onClose(response)
    }
    if (returnFocusElement) {
      dispatch(setActiveElement(returnFocusElement))
    }
  }

export const openDialogModal = createAsyncAction<void, OpenGeneralModalProps>(
  'OPEN_DIALOG_MODAL',
  async ({type, params, onConfirm, onClose, returnFocusElement}, {dispatch}) => {
    const response = await dispatch(openModal({type, params})).unwrap()

    if (response.message.reason === ModalActions.OK && onConfirm) {
      onConfirm(response)
    } else if (onClose) {
      onClose(response)
    }

    if (returnFocusElement) {
      dispatch(setActiveElement(returnFocusElement))
    }
  },
)
